const PREFIX = 'relaii:draft:v1:'
const MAX_AGE_MS = 30 * 24 * 60 * 60_000

export function draftKey(userId: string | undefined, roomId: string, threadId: string | null): string | null {
  return userId ? `${PREFIX}${JSON.stringify([userId, roomId, threadId])}` : null
}

export function loadDraft(key: string | null): string {
  if (key === null) return ''
  try {
    const raw = localStorage.getItem(key)
    if (raw === null) return ''
    const value: unknown = JSON.parse(raw)
    if (typeof value === 'object' && value !== null && 'text' in value && 'updated' in value &&
        typeof value.text === 'string' && typeof value.updated === 'number' &&
        Date.now() - value.updated < MAX_AGE_MS) return value.text
    localStorage.removeItem(key)
  } catch { /* A blocked/full cache must never prevent typing. */ }
  return ''
}

export function saveDraft(key: string | null, text: string): void {
  if (key === null) return
  try {
    if (text === '') localStorage.removeItem(key)
    else localStorage.setItem(key, JSON.stringify({ text, updated: Date.now() }))
  } catch { /* Best effort on storage-limited devices. */ }
}

export function clearDrafts(): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith(PREFIX)) localStorage.removeItem(key)
    }
  } catch { /* No accessible drafts to clear. */ }
}
